/**
 * Whether a product's style category references any swatch products.
 *
 * The fragment only pulls the raw `swatches` field value (a JSON gid list) —
 * enough to decide whether the swatch request trigger shows.
 *
 * @param {Object} productData - unwrapped Storefront product
 * @returns {Boolean}
 */
export default function hasStyleCategorySwatches(productData) {
  const swatches = productData?.styleCategory?.swatches;

  if (!swatches) return false;

  try {
    return JSON.parse(swatches).length > 0;
  } catch {
    return false;
  }
}
